import { Outlet } from '@remix-run/react'

export const handle = {
	breadcrumb: 'Typography',
}

const LayoutRoute = () => {
	return <Outlet />
}
export default LayoutRoute
